import React, { Component, Fragment } from "react"
import styles from "./styles"
import { withStyles } from "@material-ui/styles"
import {
  Typography,
  Button,
  Fab,
  Hidden,
  Box,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Switch,
} from "@material-ui/core"
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore"
import NavigateNextIcon from "@material-ui/icons/NavigateNext"
import AutoComplete from "../../components/AutoComplete"
import classNames from "classnames"

class CalendarHeaderToolbar extends Component {
  state = { isHovering: null }

  render() {
    const { props } = this

    const {
      dateShowRange,
      dateOptions,
      defaultDateOption,
      defaultFilters,
      classes,
      defaultFiltersSwitch,
      toggleFilterSwitch,
    } = props

    return (
      <Fragment>
        {/* WEB VIEW */}
        <Hidden smDown>
          <div
            style={{
              backgroundColor: "#f8f8f8",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "30px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Fab
                size="small"
                color="primary"
                className={classes.legendButton}
                onClick={() =>
                  this.props.handleToolbarControls("controls", "Prev")
                }
              >
                <NavigateBeforeIcon className={classes.controlIcon} />
              </Fab>

              <Fab
                size="small"
                color="primary"
                className={classes.legendButton}
                style={{ marginLeft: "15px" }}
                onClick={() =>
                  this.props.handleToolbarControls("controls", "Next")
                }
              >
                <NavigateNextIcon className={classes.controlIcon} />
              </Fab>

              <Typography
                variant="h2"
                style={{
                  fontSize: "1.5rem",
                  marginLeft: "32px",
                  fontWeight: 600,
                }}
              >
                {dateShowRange}
              </Typography>

              <Button
                variant="outlined"
                onClick={() =>
                  this.props.handleToolbarControls("date", "today")
                }
                className={props.classes.outlineButton}
              >
                Today
              </Button>

              {defaultFilters && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    margin: 20,
                  }}
                >
                  <Typography
                    className={classNames("", {
                      [classes.selectedDay]: defaultFiltersSwitch,
                      [classes.unselectedDay]: !defaultFiltersSwitch,
                    })}
                  >
                    Default Filters
                  </Typography>
                  <Switch
                    checked={defaultFiltersSwitch}
                    onChange={e =>
                      this.props.onToggleDefaultFilters(!defaultFiltersSwitch)
                    }
                  />
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography
                  className={classNames("", {
                    [classes.selectedDay]: !toggleFilterSwitch,
                    [classes.unselectedDay]: toggleFilterSwitch,
                  })}
                >
                  Hide Filters
                </Typography>
                <Switch
                  checked={!toggleFilterSwitch}
                  onChange={e =>
                    this.props.onToggleHideFilters(!toggleFilterSwitch)
                  }
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
              }}
            >
              <Fragment>
                <AutoComplete
                  openMenuOnClick={true}
                  defaultOptions={dateOptions}
                  showValue
                  value={defaultDateOption}
                  labelKey="name"
                  onChange={id => {
                    this.props.handleToolbarControls(
                      "date",
                      dateOptions.find(x => x.id === id).name
                    )
                  }}
                />
              </Fragment>
            </div>
          </div>
        </Hidden>

        {/* MOBILE VIEW */}
        <Hidden mdUp>
          <Fragment>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#f8f8f8",
                justifyContent: "space-evenly",
                paddingTop: "20px",
                paddingBottom: "20px",
              }}
            >
              <Fab
                size="small"
                color="primary"
                className={classes.legendButton}
                onClick={() =>
                  this.props.handleToolbarControls("controls", "Prev")
                }
              >
                <NavigateBeforeIcon className={classes.controlIcon} />
              </Fab>

              <Typography
                variant="h2"
                style={{
                  fontSize: "1.2rem",
                  fontWeight: 600,
                }}
              >
                {dateShowRange}
              </Typography>

              <Fab
                size="small"
                color="primary"
                className={classes.legendButton}
                style={{ marginLeft: "15px" }}
                onClick={() =>
                  this.props.handleToolbarControls("controls", "Next")
                }
              >
                <NavigateNextIcon className={classes.controlIcon} />
              </Fab>
            </div>
          </Fragment>
          <Fragment>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#f8f8f8",
                justifyContent: "space-evenly",
              }}
            >
              <ExpansionPanel className={classes.collapseStyles}>
                <ExpansionPanelSummary
                  className={classes.collapseSummary}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Box
                    component="div"
                    m={1}
                    className={classes.collapseSummaryRow}
                  >
                    <Typography
                      variant="p"
                      className={classes.activeCollapseOption}
                    >
                      Options
                    </Typography>
                  </Box>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.collapseDetails}>
                  <Box
                    component="div"
                    m={1}
                    className={classes.collapseDetailsContainer}
                  >
                    {dateOptions &&
                      dateOptions.map((option, i) => (
                        <Box
                          component="div"
                          m={1}
                          Key={i}
                          className={classes.collapseDetailsRow}
                          onClick={() =>
                            this.props.handleToolbarControls(
                              "date",
                              option.name
                            )
                          }
                        >
                          <Typography
                            variant="p"
                            className={
                              option.id === defaultDateOption.id
                                ? classes.activeCollapseOption
                                : {}
                            }
                          >
                            {option.name}
                          </Typography>
                        </Box>
                      ))}

                    {defaultFilters && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          margin: 20,
                        }}
                      >
                        <Typography
                          className={classNames("", {
                            [classes.selectedDay]: defaultFiltersSwitch,
                            [classes.unselectedDay]: !defaultFiltersSwitch,
                          })}
                        >
                          Default Filters
                        </Typography>
                        <Switch
                          checked={defaultFiltersSwitch}
                          onChange={e =>
                            this.props.onToggleDefaultFilters(
                              !defaultFiltersSwitch
                            )
                          }
                        />
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        margin: 20,
                      }}
                    >
                      <Typography
                        className={classNames("", {
                          [classes.selectedDay]: !toggleFilterSwitch,
                          [classes.unselectedDay]: toggleFilterSwitch,
                        })}
                      >
                        Hide Filters
                      </Typography>
                      <Switch
                        checked={!toggleFilterSwitch}
                        onChange={e =>
                          this.props.onToggleHideFilters(!toggleFilterSwitch)
                        }
                      />
                    </div>
                  </Box>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </div>
          </Fragment>
        </Hidden>
      </Fragment>
    )
  }
}

export default withStyles(styles)(CalendarHeaderToolbar)
